import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './FullScreenCode.css';

const FullScreenCode: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  return (
    <div className="full-screen-code-container" onClick={() => navigate(-1)}>
      <div className="full-screen-code-box">
        <p className="full-screen-code-label">Squad Code</p>
        <h1 className="full-screen-code-value">{code}</h1>
      </div>
      <p className="close-prompt">Click anywhere to close</p>
    </div>
  );
};

export default FullScreenCode;
